import { useGetHistoryRenewVisaDocumentGroupList } from "@/api/services/main/renew-visa";
import { IconZoomOut } from "@/assets/icons/IconZoomOut";
import { Modal } from "@/components/elements/Modal";
import { Pagination } from "@/components/elements/Pagination";
import { Table } from "@/components/elements/Table";
import { useMakeHistoryRenewVisaColumns } from "@/features/renew-visa/hook/useMakeHistoryRenewVisaColumns";
import { useTable } from "@/hooks/useTable";
import { useVisible } from "@/hooks/useVisible";
import { divider, text } from "@/theme/colors";
import { Box, Stack, styled } from "@mui/material";
import { FC } from "react";

export type TExpandRenewVisaHistoryListBtnProps = {};

export const ExpandRenewVisaHistoryListBtn: FC<TExpandRenewVisaHistoryListBtnProps> = () => {
  const expandModal = useVisible();

  const { data: historyRenewVisaDocumentList, isLoading } = useGetHistoryRenewVisaDocumentGroupList();

  const columns = useMakeHistoryRenewVisaColumns();

  const { table } = useTable({
    columns,
    rows: historyRenewVisaDocumentList?.data ?? [],
    muiTableHeadCellProps: { sx: { backgroundColor: divider.low } },
  });

  return (
    <>
      <BoxIcon onClick={() => expandModal.open()}>
        <IconZoomOut fontSize={20} color={text.primary} />
      </BoxIcon>

      <Modal width="95vw" height="80vh" title="在留期間更新の拡大表示" isOpen={expandModal.visible} onClose={expandModal.close} enableFooter={false}>
        <RenewVisaListWrapper gap={3}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Pagination totalPage={historyRenewVisaDocumentList?.pagination.totalPage} />
          </Stack>
          <Table table={table} isLoading={isLoading} maxHeight="55vh" />
        </RenewVisaListWrapper>
      </Modal>
    </>
  );
};

const BoxIcon = styled(Box)`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${divider.middle};
  border-radius: 6px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`;

const RenewVisaListWrapper = styled(Stack)`
  background-color: #ffffff;
  padding: 24px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
